import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PracticeRightSidebarTwoGridSectionOne from '../../components/practice-components/PracticeRightSidebarTwoGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const PracticeRightSidebarTwoGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Practice Right Sidebar Two Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Practice Right Sidebar Two Grid 1"
        />
        
        <PracticeRightSidebarTwoGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default PracticeRightSidebarTwoGridOne;